if (!customElements.get('collapsible-details-slider')) {
	const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	class CollapsibleDetailsSlider extends HTMLElement {
		connectedCallback() {
			this.track = this.querySelector('.collapsible-details-slider__track');
			this.slides = this.querySelectorAll('.collapsible-details-slider__slide');
			if (!this.track || this.slides.length < 2) return;

			this.panels = Array.from(this.querySelectorAll('.collapsible-details-slider__panel'));
			this.panelsWrap = this.querySelector('.collapsible-details-slider__panels');
			this.prev = this.querySelector('.collapsible-details-slider__arrow--prev');
			this.next = this.querySelector('.collapsible-details-slider__arrow--next');
			this.activeIndex = 0;

			// Built only once its row is open: a closed row costs nothing on load, and the
			// slider measures itself at its real width.
			this.details = this.closest('details');
			if (!this.details || this.details.open) {
				this.build();
				return;
			}
			this._onToggle = () => {
				if (!this.details.open) return;
				this.details.removeEventListener('toggle', this._onToggle);
				this._onToggle = null;
				this.build();
			};
			this.details.addEventListener('toggle', this._onToggle);
		}

		disconnectedCallback() {
			if (this._onToggle) this.details.removeEventListener('toggle', this._onToggle);
			if (this.flkty) {
				this.flkty.destroy();
				this.flkty = null;
			}
		}

		build() {
			if (this.flkty) return;
			if (typeof Flickity === 'undefined') {
				window.addEventListener('load', () => this.build(), { once: true });
				return;
			}

			this.flkty = new Flickity(this.track, {
				cellSelector: '.collapsible-details-slider__slide',
				cellAlign: 'left',
				contain: true,
				imagesLoaded: true,
				pageDots: true,
				prevNextButtons: false,
				rightToLeft: document.dir === 'rtl'
			});

			this.prev.addEventListener('click', () => this.flkty.previous());
			this.next.addEventListener('click', () => this.flkty.next());

			// The text above the slider follows the slide on view.
			this.flkty.on('select', () => this.showPanel(this.flkty.selectedIndex));
			this.showPanel(this.flkty.selectedIndex);
		}

		showPanel(activeIndex) {
			if (activeIndex !== this.activeIndex) this.swapPanel(activeIndex);

			// No wrap around: an arrow has nothing to do at its own end.
			this.prev.disabled = activeIndex === 0;
			this.next.disabled = activeIndex === this.slides.length - 1;
		}

		// The new text slides in from the side the slider moved to, while the block eases
		// from the height of the old text to the height of the new one.
		swapPanel(activeIndex) {
			const wrap = this.panelsWrap;
			const animate = !reducedMotion.matches;
			const fromHeight = animate ? wrap.offsetHeight : 0;

			wrap.dataset.direction = activeIndex > this.activeIndex ? 'next' : 'prev';
			this.activeIndex = activeIndex;
			this.panels.forEach((panel, index) => {
				panel.classList.toggle('active', index === activeIndex);
			});

			if (!animate) return;

			const toHeight = wrap.offsetHeight;
			if (fromHeight === toHeight) return;

			if (this.heightAnimation) this.heightAnimation.cancel();
			this.heightAnimation = wrap.animate(
				[{ height: `${fromHeight}px` }, { height: `${toHeight}px` }],
				{ duration: 300, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)' }
			);
			this.heightAnimation.onfinish = () => {
				this.heightAnimation = null;
			};
		}
	}

	customElements.define('collapsible-details-slider', CollapsibleDetailsSlider);
}
